import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  TextField,
  MenuItem,
  Button,
  Box,
  Typography,
  Grid,
  Autocomplete,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import emailjs from "emailjs-com";

import logo from "../assets/nxteye-logo.png";
import Seo from "../components/Seo";

const countries = [
  "United States",
  "Canada",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Indian Ocean Territory",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Côte d’Ivoire",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao S.A.R., China",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "North Korea",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "U.S. Virgin Islands",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican",
  "Venezuela, Bolivarian Republic of",
  "Viet Nam",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

const companyTypes = [
  "Retail: Apparel / Footwear",
  "Retail: Automotive",
  "Retail: Beauty",
  "Retail: Big Box",
  "Retail: C-Store",
  "Retail: Department Store",
  "Retail: Discounter",
  "Retail: Footwear",
  "Retail: General Merch",
  "Retail: Grocery",
  "Retail: Home Furnishings / Improvement",
  "Retail: Jeweler",
  "Retail: Pharmacy",
  "Retail: Specialty",
  "Retail: Sporting Goods",
  "Retail: Wholesale",
  "Retail: Wireless",
  "Retail: Gaming & E-Sports",
  "Solution Provider",
  "Restaurant",
  "Mall",
  "Government/Non Profit",
];

const storeCounts = [
  "1 to 20 Stores",
  "20 to 100 Stores",
  "100 to 500 Stores",
  "500+ Stores",
  "Government/Non Profit",
  "Mall Operator",
];

const PageWrapper = styled.div`
  min-height: 100vh;
  padding-top: 96px;
  // background: linear-gradient(180deg, #06121e 0%, #323e49 100%);
  background: #0c1c2c;
  color: white;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-top: 2px solid rgba(255, 255, 255, 0.2);
`;

const FormWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 80px 24px;

  @media (max-width: 768px) {
    padding: 60px 16px;
  }
`;

const FormContainer = styled.div`
  background: linear-gradient(94.99deg, #25313d 8.72%, #0d131a 98.58%);
  opacity: 0.8;
  border-radius: 16px;
  padding: 40px;
  max-width: 80%;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 768px) {
    padding: 32px 24px;
  }

  input,
  textarea {
    font-family: "Montserrat", sans-serif;
  }

  label {
    font-family: "Montserrat", sans-serif;
    color: #0c1c2c;
  }

  input[type="checkbox"] {
    margin-right: 8px;
  }
`;

const PageSection = styled.div`
  padding: 64px 24px 40px;
  text-align: center;
  font-family: "Montserrat";
`;

const PageTitle = styled.h1`
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 48px;
  line-height: 59px;
  color: #ffffff;
  text-align: center;
  margin: 16px 0;

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 42px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    line-height: 34px;
  }
`;

const PageSubtitle = styled.p`
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
  background: linear-gradient(
    106.71deg,
    #c69957 0%,
    #f7e096 47.6%,
    #a57632 93.27%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const PageDescription = styled.p`
  font-family: Source Sans Pro;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0%;
  text-align: center;
  color: #afb6d2;
  margin: 0 0 48px 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 36px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 32px;
  }
`;

const StyledTextField = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      border-radius: 8px;
      background: transparent !important;
      color: #ffffff;
    }

    .MuiOutlinedInput-root:not(.MuiInputBase-multiline) {
      height: 46px;
    }

    .MuiOutlinedInput-root input,
    .MuiOutlinedInput-root textarea {
      font-family: "Montserrat";
      font-size: 14px;
      color: #ffffff;
      padding: 12px;
    }

    .MuiOutlinedInput-root fieldset {
      border: 1px solid #a0a3bd;
    }

    .MuiOutlinedInput-root:hover fieldset {
      border-color: #a0a3bd;
    }

    .MuiOutlinedInput-root.Mui-focused fieldset {
      border-color: #a0a3bd;
    }

    .MuiInputLabel-root {
      font-family: "Montserrat";
      font-size: 14px;
      color: #a0a3bd;
    }

    /* Autofill fix */
    .MuiOutlinedInput-root input:-webkit-autofill {
      box-shadow: 0 0 0px 1000px transparent inset !important;
      -webkit-text-fill-color: #ffffff !important;
      transition: background-color 9999s ease-in-out 0s;
    }
  }
`;

const StyledAutoComplete = styled(Autocomplete)`
  && {
    .MuiOutlinedInput-root {
      border-radius: 8px;
      background: transparent;
      color: #ffffff;
      height: 46px;

      input {
        font-family: "Montserrat";
        font-size: 14px;
        color: #ffffff;
        padding: 12px;
      }

      fieldset {
        border: 1px solid #a0a3bd;
      }

      &:hover fieldset {
        border-color: #a0a3bd;
      }

      &.Mui-focused fieldset {
        border-color: #a0a3bd;
      }
    }

    .MuiInputLabel-root {
      font-family: "Montserrat";
      font-size: 14px;
      color: #a0a3bd;
    }

    .MuiAutocomplete-popupIndicator {
      color: #a0a3bd;
    }

    .MuiAutocomplete-clearIndicator {
      color: #a0a3bd;
    }

    /* Dropdown paper background */
    .MuiAutocomplete-paper {
      background-color: #0c1c2c;
      color: #ffffff;
      border: 1px solid #2c3744;
    }

    .MuiAutocomplete-noOptions,
    .custom-no-options {
      font-family: "Montserrat";
      font-size: 14px;
      color: #ffffff !important;
      padding: 8px 16px;
      opacity: 1 !important;
    }

    /* Option hover and selected */
    .MuiAutocomplete-option {
      font-family: "Montserrat";
      font-size: 14px;
      color: #ffffff;

      &:hover {
        background-color: #1a2735;
      }

      &[aria-selected="true"] {
        background-color: #2b3c4f;
      }
    }
  }
`;

const GradientButton = styled(Button)`
  min-width: 130px;
  height: 46px;
  background: linear-gradient(
    106.71deg,
    #c69957 0%,
    #f7e096 47.6%,
    #a57632 93.27%
  ) !important;

  color: #1e1d1b !important;
  font-family: "Montserrat", sans-serif !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap !important;
  box-shadow: none !important;
  padding: 8px 20px !important;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.9;
    background: linear-gradient(
      106.71deg,
      #c69957 0%,
      #f7e096 47.6%,
      #a57632 93.27%
    ) !important;
    box-shadow: none !important;
  }
`;

const FooterSection = styled.section`
  width: 100%;
  background: linear-gradient(180deg, #06121e 0%, #323e49 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }

  @media (max-width: 480px) {
    padding: 40px 16px;
  }
`;

const FooterContainer = styled.div`
  max-width: 1320px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const FooterTopRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center; /* NEW */
  gap: 48px; /* Reduced gap for better centering */
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 32px;
  }
`;

/* LEFT COLUMN – brand + nav */

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 180px;
`;

const BrandRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BrandText = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #ff8a2a;
`;

const Logo = styled.img`
  height: 32px;
`;

const FooterNavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FooterNavLink = styled.a`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  text-decoration: none;
  transition: opacity 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

/* MIDDLE + RIGHT COLUMNS – addresses */

const OfficesWrapper = styled.div`
  display: flex;
  justify-content: center; /* ✅ center both blocks */
  align-items: center; /* ensure vertical alignment */
  gap: 64px;
  flex-wrap: wrap;
  width: 100%; /* ensure proper centering area */

  @media (max-width: 768px) {
    gap: 40px;
  }
`;

const AddressBlock = styled.div`
  max-width: 360px;
  color: #ffffff;
  text-align: center; /* NEW */
  display: flex;
  flex-direction: column;
  align-items: center; /* NEW */
  justify-content: center; /* NEW */
`;

const AddressTitle = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const AddressRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 6px;
`;

const IconWrapper = styled.span`
  display: inline-flex;
  margin-top: 2px;
  font-size: 16px;
`;

const AddressText = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  opacity: 0.9;

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 20px;
  }
`;

/* DIVIDER + BOTTOM ROW */

const FullWidthDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
`;

const FooterBottomRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-top: 10px;

  @media (max-width: 768px) {
    padding-top: 16px;
  }
`;

const FooterBottomInner = styled.div`
  width: 100%;
  max-width: 1320px;
  padding: 0 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 24px;
    text-align: center;
  }
`;

const FooterText = styled.div`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
  color: #ffffff;

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const ContactRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 10px;
  color: white;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
`;

const EmailLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-family: "Montserrat", sans-serif;
  position: relative;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -2px;
    width: 0;
    height: 2px;
    background: linear-gradient(
      106.71deg,
      #c69957 0%,
      #f7e096 47.6%,
      #a57632 93.27%
    );
    transform: translateX(-50%);
    transition: width 0.3s ease;
    border-radius: 2px;
  }

  &:hover::after {
    width: 100%;
  }
`;

const PhoneIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "3px" }}
  >
    <defs>
      <linearGradient
        id="goldGradientPhone"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#C69957" />
        <stop offset="50%" stopColor="#F7E096" />
        <stop offset="100%" stopColor="#A57632" />
      </linearGradient>
    </defs>
    <path
      fill="url(#goldGradientPhone)"
      d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1v3.5a1 1 0 01-1 1C10.41 21 3 13.59 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"
    />
  </svg>
);

const MailIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "3px" }}
  >
    <defs>
      <linearGradient id="goldGradientMail" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#C69957" />
        <stop offset="50%" stopColor="#F7E096" />
        <stop offset="100%" stopColor="#A57632" />
      </linearGradient>
    </defs>
    <path
      fill="url(#goldGradientMail)"
      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm8 7L4 6v12h16V6l-8 5z"
    />
  </svg>
);

const Footer = () => {
  return (
    <FooterSection>
      <FooterContainer>
        {/* TOP ROW */}
        <FooterTopRow>
          {/* Middle + Right: Offices */}
          <OfficesWrapper>
            <AddressBlock>
              <AddressTitle>Head Office – U.A.E</AddressTitle>
              <AddressRow>
                <IconWrapper>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="white"
                      style={{ marginTop: "3px" }}
                    >
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </span>
                </IconWrapper>
                <AddressText>
                  Innovative Vision Analytics FZCO,
                  <br />
                  Office 523, Block C, Building 9W,
                  <br />
                  Dubai Airport Free Zone (DAFZA),
                  <br />
                  P.O. Box 293962, Dubai, U.A.E
                </AddressText>
              </AddressRow>
            </AddressBlock>

            <AddressBlock>
              <AddressTitle>Research &amp; Development – India</AddressTitle>
              <AddressRow>
                <IconWrapper>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="white"
                      style={{ marginTop: "3px" }}
                    >
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </span>
                </IconWrapper>
                <AddressText>
                  4th Floor, Nila Building,
                  <br />
                  Technopark Campus Phase 1,
                  <br />
                  Thiruvananthapuram, Kerala 695581
                </AddressText>
              </AddressRow>
            </AddressBlock>
          </OfficesWrapper>
        </FooterTopRow>

        <ContactRow>
          {/* Phone */}
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <PhoneIcon />
            <a
              href="tel:+971504805028"
              style={{
                color: "white",
                textDecoration: "none",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              +971 50480 5028
            </a>
          </span>

          {/* Email */}
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <MailIcon />
            <a
              href="mailto:ceo@iva.org.in"
              style={{
                color: "white",
                textDecoration: "none",
                fontFamily: "Montserrat, sans-serif",
                position: "relative",
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = "underline";
                e.target.style.textDecorationColor = "#F7E096"; // Gold underline
                e.target.style.textUnderlineOffset = "3px";
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = "none";
              }}
            >
              ceo@iva.org.in
            </a>
          </span>
        </ContactRow>

        <FullWidthDivider />

        {/* BOTTOM ROW */}
        <FooterBottomRow>
          <FooterBottomInner>
            <FooterText>Copyright © 2025 NxtEye</FooterText>
            <FooterText>Website by nxteye.com</FooterText>
          </FooterBottomInner>
        </FooterBottomRow>
      </FooterContainer>
    </FooterSection>
  );
};

export default function ContactPage() {
  const [showPopup, setShowPopup] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    location: "",
    companyType: "",
    storeCount: "",
    message: "",
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const SERVICE_ID = "service_by7q1qg"; // e.g., service_by7q1qg
  const TEMPLATE_ID = "template_b07ddaj"; // e.g., contact_form
  const PUBLIC_KEY = "xnpBxXOQfchaDk7KA"; // from EmailJS dashboard

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          location: formData.location,
          companyType: formData.companyType,
          storeCount: formData.storeCount,
          message: formData.message,
        },
        PUBLIC_KEY
      )
      .then(() => {
        setShowPopup(true); // show the popup
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          location: "",
          companyType: "",
          storeCount: "",
          message: "",
        });

        // Auto-close after 5 seconds
        setTimeout(() => setShowPopup(false), 5000);
      })
      .catch((error) => {
        console.error("Failed to send:", error);
        alert("There was an error. Please try again.");
      });
  };

  return (
    <>
      <Seo
        title="Contact NxtEye – Book a Demo"
        description="Schedule a demo and explore how NxtEye transforms luxury retail experiences."
        url="https://nxteye.com/#/contact"
      />

      <PageWrapper>
        <PageSection>
          <PageSubtitle>Get in touch</PageSubtitle>
          <PageTitle>Let us know how we can help you.</PageTitle>
          <PageDescription>
            See how NxtEye can elevate your customer engagement and boost sales
            in high-end retail environments
          </PageDescription>
        </PageSection>

        <FormWrapper>
          <FormContainer>
            <Box
              component="form"
              display="flex"
              flexDirection="column"
              gap={3}
              onSubmit={handleSubmit}
            >
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography variant="body2" sx={{ color: "#a0a3bd", mb: 1 }}>
                    First Name *
                  </Typography>
                  <StyledTextField
                    fullWidth
                    required
                    variant="outlined"
                    value={formData.firstName}
                    onChange={handleChange("firstName")}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography variant="body2" sx={{ color: "#a0a3bd", mb: 1 }}>
                    Last Name *
                  </Typography>
                  <StyledTextField
                    fullWidth
                    required
                    variant="outlined"
                    value={formData.lastName}
                    onChange={handleChange("lastName")}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Typography variant="body2" sx={{ color: "#a0a3bd", mb: 1 }}>
                    Email *
                  </Typography>
                  <StyledTextField
                    fullWidth
                    required
                    variant="outlined"
                    value={formData.email}
                    onChange={handleChange("email")}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Typography variant="body2" sx={{ color: "#a0a3bd", mb: 1 }}>
                    Company Location *
                  </Typography>
                  <StyledAutoComplete
                    options={countries}
                    value={formData.location}
                    onChange={(event, newValue) =>
                      setFormData({ ...formData, location: newValue || "" })
                    }
                    renderInput={(params) => (
                      <StyledTextField {...params} variant="outlined" />
                    )}
                    fullWidth
                    autoHighlight
                    clearOnEscape
                    noOptionsText={
                      <span
                        style={{
                          fontFamily: "Montserrat",
                          fontSize: "14px",
                          color: "#ffffff",
                          padding: "8px 16px",
                          display: "block",
                        }}
                      >
                        No options
                      </span>
                    }
                    componentsProps={{
                      paper: {
                        sx: {
                          background:
                            "linear-gradient(94.99deg, #25313d 8.72%, #0d131a 98.58%)",
                          color: "#ffffff",
                          border: "1px solid #2c3744",
                          "& .MuiAutocomplete-option": {
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#ffffff",
                            "&[aria-selected='true']": {
                              backgroundColor: "#2b3c4f",
                            },
                            "&:hover": {
                              backgroundColor: "#1a2735",
                            },
                          },
                        },
                      },
                      noOptions: {
                        className: "custom-no-options",
                      },
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Typography variant="body2" sx={{ color: "#a0a3bd", mb: 1 }}>
                    Which option best describes your company? *
                  </Typography>
                  <StyledAutoComplete
                    options={companyTypes}
                    value={formData.companyType}
                    onChange={(event, newValue) =>
                      setFormData({ ...formData, companyType: newValue || "" })
                    }
                    renderInput={(params) => (
                      <StyledTextField {...params} variant="outlined" />
                    )}
                    fullWidth
                    autoHighlight
                    clearOnEscape
                    noOptionsText={
                      <span
                        style={{
                          fontFamily: "Montserrat",
                          fontSize: "14px",
                          color: "#ffffff",
                          padding: "8px 16px",
                          display: "block",
                        }}
                      >
                        No options
                      </span>
                    }
                    componentsProps={{
                      paper: {
                        sx: {
                          background:
                            "linear-gradient(94.99deg, #25313d 8.72%, #0d131a 98.58%)",
                          color: "#ffffff",
                          border: "1px solid #2c3744",
                          "& .MuiAutocomplete-option": {
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#ffffff",
                            "&[aria-selected='true']": {
                              backgroundColor: "#2b3c4f",
                            },
                            "&:hover": {
                              backgroundColor: "#1a2735",
                            },
                          },
                        },
                      },
                      noOptions: {
                        className: "custom-no-options",
                      },
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Typography variant="body2" sx={{ color: "#a0a3bd", mb: 1 }}>
                    Number of stores you have right now*
                  </Typography>
                  <StyledAutoComplete
                    options={storeCounts}
                    value={formData.storeCount}
                    onChange={(event, newValue) =>
                      setFormData({ ...formData, storeCount: newValue || "" })
                    }
                    renderInput={(params) => (
                      <StyledTextField {...params} variant="outlined" />
                    )}
                    fullWidth
                    autoHighlight
                    clearOnEscape
                    noOptionsText={
                      <span
                        style={{
                          fontFamily: "Montserrat",
                          fontSize: "14px",
                          color: "#ffffff",
                          padding: "8px 16px",
                          display: "block",
                        }}
                      >
                        No options
                      </span>
                    }
                    componentsProps={{
                      paper: {
                        sx: {
                          background:
                            "linear-gradient(94.99deg, #25313d 8.72%, #0d131a 98.58%)",
                          color: "#ffffff",
                          border: "1px solid #2c3744",
                          "& .MuiAutocomplete-option": {
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#ffffff",
                            "&[aria-selected='true']": {
                              backgroundColor: "#2b3c4f",
                            },
                            "&:hover": {
                              backgroundColor: "#1a2735",
                            },
                          },
                        },
                      },
                      noOptions: {
                        className: "custom-no-options",
                      },
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Typography variant="body2" sx={{ color: "#a0a3bd", mb: 1 }}>
                    Message
                  </Typography>
                  <StyledTextField
                    fullWidth
                    multiline
                    minRows={5}
                    variant="outlined"
                    value={formData.message}
                    onChange={handleChange("message")}
                  />
                </Grid>
                <Box mt={3}>
                  <Box display="flex" alignItems="flex-start">
                    <input
                      type="checkbox"
                      id="marketingOptIn"
                      style={{ marginTop: 3, marginRight: 8 }}
                    />
                    <Box>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        sx={{ color: "#ffffff", fontFamily: "Montserrat" }}
                      >
                        Keep me up to date on the latest in retail and retail
                        analytics
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#a0a3bd",
                          fontFamily: "Montserrat",
                          display: "block",
                          mt: 0.5,
                        }}
                      >
                        By checking the box, you agree to receive marketing
                        communications from <strong>NxtEye</strong>.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  width="100%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  mt={2}
                  flexWrap="wrap"
                >
                  <GradientButton
                    type="submit"
                    sx={{ borderRadius: "18px", mt: { xs: 2, md: 0 } }}
                  >
                    Send Message
                  </GradientButton>

                  <Typography
                    variant="caption"
                    sx={{
                      color: "#a0a3bd",
                      fontFamily: "Montserrat",
                      mt: 1,
                    }}
                  >
                    We will only use the information we collect or receive about
                    you in accordance with the NxtEye{" "}
                    <a href="#" style={{ color: "#00bcd4" }}>
                      Privacy Policy
                    </a>
                    .
                  </Typography>
                </Box>
              </Grid>
            </Box>
          </FormContainer>
        </FormWrapper>
      </PageWrapper>

      {showPopup && (
        <Box
          sx={{
            position: "fixed",
            top: { xs: "30%", sm: "30%" },
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#0c1c2c",
            color: "#ffffff",
            px: { xs: 3, sm: 4 }, // horizontal padding
            py: { xs: 2.5, sm: 3 }, // vertical padding
            borderRadius: "16px",
            boxShadow: "0px 12px 40px rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            textAlign: "center",
            fontFamily: "Montserrat",
            width: {
              xs: "80%", // Mobile
              sm: "auto", // Tablets and up
            },
            maxWidth: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CheckCircleIcon
            sx={{ fontSize: { xs: 40, sm: 48 }, color: "#7BC67B", mb: 1 }}
          />
          <Typography
            variant="h6"
            sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, mb: 0.5 }}
          >
            Thank you for filling the form!
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: { xs: "0.85rem", sm: "1rem" } }}
          >
            We will get back to you shortly.
          </Typography>
        </Box>
      )}

      <Footer />
    </>
  );
}
